import React from "react"
import { IconProp } from "@fortawesome/fontawesome-svg-core"
import { faBuilding, faUser, faEnvelope } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Form, Input } from "antd"
import { useTranslation } from "react-i18next"

interface ConfirmInvitationFormContentProps {}

const ConfirmInvitationFormContent: React.FC<ConfirmInvitationFormContentProps> = () => {
  const { t } = useTranslation()
  return (
    <>
      <Form.Item name="orgName" label={t("common.forms.businessName")}>
        <Input
          className="font-normal rounded-md"
          prefix={
            <>
              <FontAwesomeIcon
                className="h-4 flex-shrink-0 text-gray-400 mr-2 cursor-pointer"
                icon={faBuilding as IconProp}
              />
            </>
          }
          disabled
        />
      </Form.Item>
      <Form.Item name="name" label={t("common.fullName")}>
        <Input
          className="font-normal rounded-md"
          placeholder={t("common.enterFullName")}
          disabled
          prefix={
            <FontAwesomeIcon
              className="h-4 flex-shrink-0 text-gray-400 mr-2 cursor-pointer"
              icon={faUser as IconProp}
            />
          }
        />
      </Form.Item>
      <Form.Item id="email" name={"email"} label={t("common.email")} className="mb-4">
        <Input
          name="email"
          className="font-normal rounded-md"
          placeholder={t("onboarding.CreateOrgForm.yourProfessionalEmailAddress")}
          disabled
          prefix={
            <FontAwesomeIcon
              className="flex-shrink-0 text-gray-400 ml-1 mr-2"
              icon={faEnvelope as IconProp}
            />
          }
        />
      </Form.Item>
    </>
  )
}

export default ConfirmInvitationFormContent
